import {
  ADD_GRADE_FAILURE,
  ADD_GRADE_LOADING,
  ADD_GRADE_SUCCESS,
  DELETE_GRADE_FAILURE,
  DELETE_GRADE_LOADING,
  DELETE_GRADE_SUCCESS,
  FETCH_GRADE_FAILURE,
  FETCH_GRADE_LOADING,
  FETCH_GRADE_SUCCESS,
  UPDATE_GRADE_FAILURE,
  UPDATE_GRADE_LOADING,
  UPDATE_GRADE_SUCCESS
} from '../Types/gradeTypes';

const initState = {
  data: [],
  error: null,
  success: null,
  loading: true,
  item: {}
};

const gradeReducer = function (state = initState, action) {
  switch (action.type) {
    case FETCH_GRADE_LOADING:
    case ADD_GRADE_LOADING:
    case UPDATE_GRADE_LOADING:
    case DELETE_GRADE_LOADING:
      return {
        ...state,
        loading: true
      };

    case FETCH_GRADE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: null,
        data: action.payload
      };
    case ADD_GRADE_SUCCESS:
      return {
        ...state,
        data: [...state.data, action.payload],
        loading: false,
        error: null,
        success: 'Grade added successfully'
        // item: action.payload
      };

    case UPDATE_GRADE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.map(item => (item._id === action.payload._id ? action.payload : item)),
        error: null,
        success: 'Grade updated successfully'
      };

    case DELETE_GRADE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: 'Grade removed successfully',
        data: state.data.filter(grade => grade._id !== action.payload)
      };

    case FETCH_GRADE_FAILURE:
    case ADD_GRADE_FAILURE:
    case UPDATE_GRADE_FAILURE:
    case DELETE_GRADE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null
      };

    default:
      return { ...state };
  }
};

export default gradeReducer;
